import { CasterDataEntryPage } from "./DataEntryPage";
import {
  CasterDataEntryProvider,
  useDataEntryContext,
} from "./context/reducer.provider";
import { TimerProvider } from "./context/timer.provider";
import { themeMESF } from "@dexteel/mesf-core";
import { ThemeProvider } from "@mui/material/styles";

type Props = {};
const CasterDataEntry = (props: Props) => {
  return (
    <CasterDataEntryProvider>
      <TimerProviderWrapper />
    </CasterDataEntryProvider>
  );
};

const TimerProviderWrapper = () => {
  const { state } = useDataEntryContext();

  return (
    <TimerProvider isOldProcess={!!state.deProcess?.process.IsOldProcess}>
      <div id={"dummy"} style={{ height: "0", width: "0" }}></div>
      <ThemeProvider theme={themeMESF}>
        <CasterDataEntryPage />
      </ThemeProvider>
    </TimerProvider>
  );
};
export default CasterDataEntry;
